import { render, staticRenderFns } from "./MarkDuplicatedModal.vue?vue&type=template&id=5a0c11c8&scoped=true"
import script from "./MarkDuplicatedModal.vue?vue&type=script&lang=js"
export * from "./MarkDuplicatedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0c11c8",
  null
  
)

export default component.exports